export default __webpack_public_path__ + "static/media/caratteristicheBg.01288d24.jpg";